module.exports = __webpack_public_path__ + "img/logo.afafd30d.png";